import { useMemo } from 'react';

import useTrls from 'hooks/translation/useTrls';

export enum TranslationNamespaces {
    Campaign,
    AdCreate,
}

const KEYS_GENERATORS_MAP = {
    [TranslationNamespaces.Campaign]: () => ({
        zero: `campaign.targetings.profRoles.zero`,
        one: `campaign.targetings.profRoles.one`,
        some: `campaign.targetings.profRoles.some`,
        many: `campaign.targetings.profRoles.many`,
        title: `campaign.targetings.profRoles.title`,
        additional: 'campaign.targetings.additional',
        close: 'campaign.targetings.close',
    }),
    [TranslationNamespaces.AdCreate]: () => ({
        all: `AdCreate.AdForm.ProfRoles.all`,
        legend: `AdCreate.AdForm.ProfRoles.legend`,
        title: `AdCreate.AdForm.ProfRoles.Popup.title`,
        searchPlaceholder: `AdCreate.AdForm.ProfRoles.Popup.searchPlaceholder`,
        searchPlaceholderMagritte: `AdCreate.AdForm.ProfRoles.Popup.searchPlaceholderMagritte`,
        resetButton: `AdCreate.AdForm.ProfRoles.Popup.resetButton`,
    }),
};

const useProfRolesTranslations = <T extends TranslationNamespaces>(
    namespace: T,
    translateKeys?: boolean
): Record<keyof ReturnType<(typeof KEYS_GENERATORS_MAP)[T]>, string> => {
    const trls = useTrls();

    return useMemo(() => {
        const keys = KEYS_GENERATORS_MAP[namespace]() as unknown as Record<
            keyof ReturnType<(typeof KEYS_GENERATORS_MAP)[T]>,
            string
        >;

        if (!translateKeys) return keys;

        return Object.entries(keys).reduce((result, [key, translation]) => {
            result[key as keyof typeof keys] = trls(translation);

            return result;
        }, keys);
    }, [namespace, translateKeys, trls]);
};

export default useProfRolesTranslations;
